import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "me-2" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = { class: "me-2 d-flex align-items-center" }
const _hoisted_6 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _cache[1] || (_cache[1] = _createTextVNode("Bonus per livello ")),
      _cache[2] || (_cache[2] = _createElementVNode("b", null, "(1 è l'upliner diretto)", -1)),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-success btn-sm",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
      }, "+")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "d-flex mt-2",
        key: i
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger btn-sm me-2",
          onClick: ($event: any) => (_ctx.removeRow(i))
        }, "-", 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            readonly: true,
            class: "form-control",
            "onUpdate:modelValue": ($event: any) => ((item.level) = $event)
          }, null, 8, _hoisted_4), [
            [_vModelText, item.level]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": ($event: any) => ((item.paymentAmount) = $event),
            placeholder: "€ pagati"
          }, null, 8, _hoisted_6), [
            [_vModelText, item.paymentAmount]
          ]),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fs-22 ms-2" }, "€", -1))
        ])
      ]))
    }), 128))
  ]))
}